import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2b593900&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=2b593900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../AppPlus/H5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b593900",
  null
  
)

export default component.exports